import React, { useState, lazy, Suspense, useCallback, useEffect, useContext } from "react"
import styled from "styled-components"
import Store from "@airasia/phoenix-widgets/widgets/Store"
import FSW_DATA from "../data/phoenix/searchWidget"
import Title from "@airasia/phoenix-components/components/Title"
import FlightSearchWidget from "@airasia/phoenix-widgets/widgets/FlightSearchWidget"
import _ from "lodash"
import Axios from "axios"
import { GlobalContext } from "../functions"


import {
  TOMORROW_DDMMYYY,
  THREE_DAYS_FROM_TODAY_DDMMYYY,
} from "../utils/constant"
import { splitRouteNameToArray } from "../utils/function"
import axios from "axios"
import { CircularProgress } from "@material-ui/core"

// import "../Css/phoenix.css"

// import Loadable from "@loadable/component"

// const FlightSearchWidget = Loadable(() => import("./FlightSearchWidget"))

const BigTitle = styled(Title)`
  font-size: 3rem !important;
  text-align: left !important;
  margin-bottom: 16px;
`;

const BannerContainer = styled.div(
  ({image, isLarger }) => `
   {
    height: ${isLarger ? '80vh' : '450px'};
    ${isLarger ? 'min-height : 600px;' : ''}
    width: 100%;
    background: 50% 50% / cover no-repeat;
    background-position: center;
    background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0.3)
      ),
      url(${image}), url("https://storage.googleapis.com/static.stgairasia.com/seo/static-assets/SEOFlightsImages/hero/just-sky.jpeg");
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`
)

const MobileBannerContainer = styled.div(
  ({image }) => `
   {
    width: 100%;
    background: 50% 50% / cover no-repeat;
    background-position: center;
    background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0.3)
      ),
      url(${image}), url("https://storage.googleapis.com/static.stgairasia.com/seo/static-assets/SEOFlightsImages/hero/just-sky.jpeg");
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 16px;
  }
`
)
const StyledHeading = styled.div`
  margin: 10px;
  #banner-title {
    font-size: 1.6rem;
  }
`

const FswContainer = styled.div`
  padding: 16px 48px;
  background: white;
`;

const HSW_Wrapper = styled.div`
  margin: 20px;
  // background: white;
  // padding: 30px;
  // border-radius: 20px;
  // height: 150px;
  // width: 880px;
  display: block;
  @media only screen and (max-width: 1440px) {
    width: 1080px;
    // height: 150px;
  }

  @media only screen and (max-width: 1024px) {
    width: 880px;
    // height: 150px;
  }

  @media only screen and (max-width: 768px) {
    margin: 0 50px 50px 50px;
    padding: 10px;
    align-self: stretch;
    width: 650px;
    height: 440px;
  }

  @media only screen and (max-width: 600px) {
    margin: 0 20px 20px 20px;
    padding: 10px;
    align-self: stretch;
  }

  @media only screen and (max-width: 540px) {
    margin: 0 20px 20px 20px;
    padding: 10px;
    align-self: stretch;
    width: 460px;
    height: 545px;
  }
  @media only screen and (max-width: 414px) {
    width: 350px;
    height: 545px;
  }
  @media only screen and (max-width: 375px) {
    width: 315px;
    height: 545px;
  }
  @media only screen and (max-width: 360px) {
    width: 300px;
    height: 545px;
  }
  @media only screen and (max-width: 320px) {
    width: 260px;
    height: 545px;
  }
  @media only screen and (max-width: 280px) {
    width: 250px;
    height: 545px;
    margin: 0 20px 20px 5px;
  }
 
`
const HSW_Wrapper_Mobile = styled.div`
  margin: 20px;
  background: white;
  padding: 30px;
  border-radius: 4px;
  /* height: 415px;
  width: 260px; */

  /* width: 880px; */
  @media only screen and (max-width: 1024px) {
    width: 880px;
    height: 120px;
  }

  @media only screen and (max-width: 768px) {
    // margin: 0 50px 50px 50px;
    margin: auto;
    padding: 1px;
    align-self: stretch;
    width: 85vw;
    max-width: 720px;
    // height: 545px;
    height: auto;
  }

  @media only screen and (max-width: 600px) {
    // margin: 0 20px 20px 20px;
    margin: auto;
    padding: 10px;
    align-self: stretch;
  }

  @media only screen and (max-width: 540px) {
    // margin: 0 20px 20px 20px;
    margin: auto;
    padding: 1px;
    // align-self: stretch;
    width: 85vw;
    // height: 545px;
    height: auto;

  }
  @media only screen and (max-width: 414px) {
    width: 350px;
    // height: 545px;
    height: auto;
    padding: 1px;

  }
  @media only screen and (max-width: 375px) {
    width: 315px;
    // height: 545px;
    height: auto;

  }
  @media only screen and (max-width: 360px) {
    width: 300px;
    // height: 545px;
    height: auto;

  }
  @media only screen and (max-width: 320px) {
    width: 260px;
    // height: 545px;
    height: auto;

  }
  @media only screen and (max-width: 280px) {
    width: 250px;
    // height: 545px;
    height: auto;
    margin: 0 20px 20px 5px;
  }
 
`

const MobileContainer = styled.div`
   @media only screen and (min-width: 769px) {
    display: none;
   }
`

const DesktopContainer = styled.div`
   @media only screen and (max-width: 768px) {
    display: none;
   }
`

const MobileWidgetTextPromo = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    background: #0E7738;
    color: white;
    border-radius: 4px 4px 0px 0px;
    padding-block: 4px;
`;

const getSnapAvailability = async (searchObj) => {
  let bodyData = {
    "vars": ["snap_flight_price_checkbox"],
    "env": "production",
    "tags": {
      "airportOrig": _.get(searchObj, 'origin.StationCode', ""),
      "airportDest": _.get(searchObj, 'destination.StationCode', ""),
      "journeyType": _.get(searchObj, 'tripType', ""),
      "promoCode": _.get(searchObj, 'promoCode', ""),
      "adults": _.get(searchObj, 'passengers.adult', 0),
      "children": _.get(searchObj, 'passengers.child', 0),
      "infant": _.get(searchObj, 'passengers.infant', 0),
      "platform": "dweb",
      // "user_id": "GA1.2.378908598.1652076962"
    }
  }

  return await Axios.post(process.env.GATSBY_ENV === 'dev' ? '/relay-api/relay/query' : 'https://track.data.airasia.com/relay/query', bodyData).then(resp => {
    console.log('resp from getSnapAvailability --- ', resp);
    let snapDataRaw = _.get(resp, 'data.snap_flight_price_checkbox.value');
    let snapData = _.isString(snapDataRaw) ? JSON.parse(snapDataRaw) : snapDataRaw;
    return _.get(snapData, 'is_enabled', false)
  }).catch(err => {
    console.log('err from getSnapAvailability --- ', err);
    return false;
  })

}

export default function Banner(props) {
  const { image, title, isMobile, currentRoute } = props
  const [showMobileFSW, setShowMobileFSW] = useState(false);
  const [isSnapAvailable, setIsSnapAvailable] = useState(false);
  const [fswData, setFswData] = useState(FSW_DATA.data);
  const [isLoadingFSWData, setIsLoadingFSWData] = useState(true);
  const globalState = useContext(GlobalContext)


  useEffect(()=>{
    setIsLoadingFSWData(true);
    axios.get(`https://static.airasia.com/cosmos/universalsearchwidget/flight/${props.lang}/file.json`).then(resp => {
      setFswData(_.get(resp, "data", {}));
      setIsLoadingFSWData(false);
    }).catch(err => {
      console.error("Error fetching universal search widget props::: ", err);
      setIsLoadingFSWData(false);
    })
  }, [])

  // const isOnClient = typeof window !== "undefined"
  if (typeof window !== "undefined") {
    window.gtmDataLayer = window.gtmDataLayer || []
  }
  const onMobileBannerClick = () => {
    setShowMobileFSW(true)
  }
  const FSWGtmFire = () => {
    const obj = {
      event: "trackEventNoEcommerce",
      "eventDetails.category": "SEO Flights | Search Widget",
      "eventDetails.action": `view`,
      "eventDetails.label": `Flights Widget Exposed`,
    }

    if (typeof window !== "undefined") {
      window.gtmDataLayer = window.gtmDataLayer || []
      window.gtmDataLayer.push(obj)
    }
  }
  const onMobileFSWClose = () => {
    document.body.style.overflow = "auto"
    setShowMobileFSW(false)
  }

  const route = _.isString(currentRoute)
    ? splitRouteNameToArray(currentRoute)
    : ["KUL", "LGK"]
  const fswPrefill = {
    depart: TOMORROW_DDMMYYY,
    from: route[0],
    passengers: {
      adult: 2,
      child: 0,
      infant: 0,

    },
    return: THREE_DAYS_FROM_TODAY_DDMMYYY,
    to: route[1],
    tripType: "R",
    // cabinClass: "economy"
  }

  const handleSearchChange = useCallback(async (searchObj) => {
    let isAvailable = await getSnapAvailability(searchObj);
    console.log('isAvailable from handleSearchChange --- ', isAvailable);
    setIsSnapAvailable(isAvailable);
  }, [getSnapAvailability])

  const [currency, setCurrency] = useState(()=>{
    let temp = _.get(globalState, "currency", "MYR");
    return temp
  });

  useEffect(()=>{
    console.log("changing the currency from useEffect --- ", _.get(globalState, "currency", ""));
    // dispat
    setCurrency(()=>{
      let temp = _.get(globalState, "currency", "MYR");
      return temp
    })
  }, [globalState])

  return (
    <>
        {/* {isMobile ? ( */}
          <MobileContainer>
            <MobileBannerContainer image={image}>
              <StyledHeading>
                <Title
                  type={isMobile?"h1":"h2"}
                  color="default"
                  customProperties={{
                    id: "banner-title",
                  }}
                  textAlign="center"
                >
                  {isMobile?title:""}
                </Title>
              </StyledHeading>
                <HSW_Wrapper_Mobile>
                {/* <MobileWidgetTextPromo>Lowest AirAsia Fares Guaranteed!</MobileWidgetTextPromo> */}
                  <Store>
                    {
                      isLoadingFSWData 
                        ? <div style={{display: "grid", placeItems: "center"}}><CircularProgress /> </div>
                        : <FlightSearchWidget
                            accessible
                            // currency={_.get(globalState, "currency", "MYR")}
                            currency={props?.currency || ""}
                            // data={FSW_DATA.data}
                            data={fswData}
                            enableDataVisor={false}
                            enableLFC={false}
                            enableLFCV2
                            domain="com"
                            enableOnSearchCookieReset
                            // endpointConfig={FSW_DATA.endpointConfig}
                            endpointConfig={JSON.parse(JSON.stringify(_.get(fswData, "ENDPOINT_CONFIG[0].data", FSW_DATA.endpointConfig)).replace('/v2', '/v3'))}
                            // environment={["dev", "stg"].includes(process.env.GATSBY_ENV) ? "STAGING" : "PRODUCTION"}
                            environment={process.env.GATSBY_ENV === "dev" ? "DEVELOPMENT" : process.env.GATSBY_ENV === "stg" ? "STAGING" : "PRODUCTION"}
                            invertSearchButtonStyle={false}
                            isEdit={false}
                            isSearchWidgetOpenByDefault={false}
                            isShowSnapCheckbox={isSnapAvailable}
                            isShowSnapInNewWindow={false}
                            locale={props.lang}
                            onValueChange={function noRefCheck(){}}
                            openContextualSearchWidgetbyDefault={false}
                            redirectUrl="https://www.airasia.com"
                            showBackGroundColor="default"
                            showBorder={false}
                            showIconBackground={false}
                            showMobileViewWithoutModal
                            theme={props?.theme || "AIRASIA_MOVE"}
                            showCabinClass
                            unifiedListingConfig={{airlineProfile: "all", type: "paired"}}
                            viewport="mobile"
                            preFill={null}
                            fireGtm={obj => {
                              try{
                                if(typeof(window) !== "undefined"){
                                  window.gtmDataLayer.push(obj)
                                }
                              }catch(err){
                                console.error("Error in firing GTM event", err);
                              }
                            }}
                            originOrDestinationNotFoundEventHandler={obj => {
                              try{
                                if(typeof(window) !== "undefined"){
                                  window.gtmDataLayer.push(obj)
                                }
                              }catch(err){
                                console.error("Error in firing GTM event", err);
                              }
                            }}
                            useV3Bucket
                            cityLevelGrouping
                            isAirAsiaFlightOnlyCheckbox
                            airAsiaFlightOnlyValueFromListing
                            gtmParameters={{appName: "SEO Flights"}}
                            enableTravelSearchService
                      />
                    }
                    
                  </Store>
                </HSW_Wrapper_Mobile>
            </MobileBannerContainer>
          </MobileContainer>
          <DesktopContainer>
            <BannerContainer isLarger image={image}>
                <HSW_Wrapper>
                <BigTitle type={!isMobile?"heroBanner":"h2"} color="default">
                  {!isMobile?title:""}
                </BigTitle>
                  <Store>
                    <FswContainer>
                      {
                        isLoadingFSWData 
                        ? <div style={{display: "grid", placeItems: "center"}}><CircularProgress /> </div>
                        : <FlightSearchWidget
                            accessible
                            agentId={null}
                            beforeRedirectHandler={null}
                            closeSearchWidget={function noRefCheck(){}}
                            // currency={_.get(globalState, "currency", "USD")}
                            // currency={currency}
                            currency={props?.currency || ""}
                            // data={FSW_DATA.data}
                            data={fswData}
                            enableDataVisor={false}
                            enableLFC={false}
                            enableLFCV2
                            domain="com"
                            enableOnSearchCookieReset
                            endpointConfig={JSON.parse(JSON.stringify(_.get(fswData, "ENDPOINT_CONFIG[0].data", FSW_DATA.endpointConfig)).replace('/v2', '/v3'))}
                            environment={process.env.GATSBY_ENV === "dev" ? "DEVELOPMENT" : process.env.GATSBY_ENV === "stg" ? "STAGING" : "PRODUCTION"}
                            invertSearchButtonStyle={false}
                            isEdit={false}
                            isSearchWidgetOpenByDefault={false}
                            isShowSnapCheckbox={isSnapAvailable}
                            isShowSnapInNewWindow={false}
                            locale={props.lang}
                            onValueChange={handleSearchChange}
                            openContextualSearchWidgetbyDefault={false}
                            redirectUrl="https://www.airasia.com"
                            showBackGroundColor="default"
                            showBorder={false}
                            showIconBackground={false}
                            showMobileViewWithoutModal={false}
                            theme={props?.theme || "AIRASIA_MOVE"}
                            showCabinClass
                            unifiedListingConfig={{airlineProfile: "all", type: "paired"}}
                            viewport="desktop"
                            preFill={null}
                            fireGtm={obj => {
                              try{
                                if(typeof(window) !== "undefined"){
                                  window.gtmDataLayer.push(obj)
                                }
                              }catch(err){
                                console.error("Error in firing GTM event", err);
                              }
                            }}
                            originOrDestinationNotFoundEventHandler={obj => {
                              try{
                                if(typeof(window) !== "undefined"){
                                  window.gtmDataLayer.push(obj)
                                }
                              }catch(err){
                                console.error("Error in firing GTM event", err);
                              }
                            }}
                            useV3Bucket
                            cityLevelGrouping
                            isAirAsiaFlightOnlyCheckbox
                            airAsiaFlightOnlyValueFromListing
                            gtmParameters={{appName: "SEO Flights"}}
                            enableTravelSearchService
                      />
                      }
                      
                    </FswContainer>
                  </Store>
                </HSW_Wrapper>
            </BannerContainer>
          </DesktopContainer>
      </>
  )
}
